import React from 'react';
import Button, { ButtonVariantType } from '@dealroadshow/uikit/core/components/Button';
import RequestServiceModal from '@/finsight/ui/common/components/RequestServiceModal';

import styles from './styles.scss';

interface IProps {
  imgUrl: string,
  imgAlt: string,
  title: string | React.ReactElement,
  description: string | React.ReactElement,
  onButtonClick: () => void,
  dataTest: string,
}

const RequestQuotePanel = ({ imgUrl, imgAlt, title, description, onButtonClick, dataTest }: IProps) => (
  <div className={ styles.requestQuotePanel } data-test={ dataTest }>
    <div className={ styles.requestQuotePanelContent }>
      <div>
        <img
          alt={ imgAlt }
          src={ imgUrl }
        />
      </div>
      <div className={ styles.requestQuotePanelText }>
        <div className={ styles.requestQuotePanelTitle }>{ title }</div>
        <div className={ styles.requestQuotePanelDescription }>
          { description }
        </div>
      </div>
    </div>
    <Button
      variant={ ButtonVariantType.action }
      title="Talk to Sales"
      dataTest={ `${ dataTest }Button` }
      className={ styles.requestQuotePanelButton }
      onClick={ onButtonClick }
    />
    <RequestServiceModal />
  </div>
);

export default RequestQuotePanel;
